import { ABLY_API_KEY } from "../utils/variables";

export const ABLY_OPTIONS = {
  key: ABLY_API_KEY,
  log: { level: 0 },
};
